import { __ } from '@wordpress/i18n';

export const generalStyleTabs = [
	{ name: 'general', title: __('General', 'textdomain') },
	{ name: 'style', title: __('Style', 'textdomain') }
];

export const themeOptions = [
	{ label: 'Style One', value: 'style-1' },
	{ label: 'Style Two', value: 'style-2' }
]

export const resetCardPadding = { "top": "20px", "right": "24px", "bottom": "20px", "left": "24px" };
export const resetcardMargin = { "top": "0px", "right": "0px", "bottom": "16px", "left": "0px" };
export const resetCardPeriodMargin = { "top":"0px", "right": "0px", "bottom": "0px", "left": "5px" };
export const resetcardDesMargin = {"top": "0px", "right": "0px", "bottom":"16px", "left": "0px"};
export const resetCardButtonPadding = { "top": "10px", "right": "16px", "bottom": "10px", "left": "16px" };
export const resetFeaturesPadding = { "top": "0px", "right": "24px", "bottom": "20px", "left": "24px" };
export const resetFeaturesMargin = { "top": "0px", "right": "0px", "bottom": "8px", "left": "0px" };
export const resetIconMargin = { "top": "6px", "right": "8px", "bottom": "0px", "left": "0px" };
export const resetCardButtonRadius = { "top": "6px", "right": "6px", "bottom": "6px", "left": "6px" };
export const resetRadius = { "top": "8px", "right": "8px", "bottom": "8px", "left": "8px" };
export const resetHightRadius = { "top": "4px", "right": "4px", "bottom": "4px", "left": "4px" };
export const paddingReset = { "top": "4px", "right": "12px", "bottom": "4px", "left": "12px" };

// style 2
export const resetCardMargin = { "top": "0px", "right": "0px", "bottom": "8px", "left": "0px" };
export const resetCardPaddingTwo = { "top": "32px", "right": "32px", "bottom": "32px", "left": "32px" };
export const resetPriceMargin = { "top": "0px", "right": "0px", "bottom": "4px", "left": "0px" };
export const resetButtonRadius = { "top": "8px", "right": "8px", "bottom": "8px", "left": "8px" };
export const resetgetStartedPadding = { "top": "13px", "right": "16px", "bottom": "13px", "left": "16px" };
export const resetFeaturedRadius = { top: "8px", right: "8px", bottom: "8px", left: "8px" };
export const resetFeaturedPadding = { "top": "32px", "right": "32px", "bottom": "32px", "left": "32px" };
export const resetFeaturesPaddingTwo = { "top": "32px", "right": "32px", "bottom": "32px", "left": "32px" };
export const resetFeaturedPaddingTwo = { "top": "32px", "right": "32px", "bottom": "32px", "left": "32px" };
export const featuredTitleMargin = { "top": "0px", "right": "0px", "bottom": "8px", "left": "0px" };
export const featuredPriceingMargin = { "top": "0px", "right": "0px", "bottom": "4px", "left": "0px" };
export const resetFeaturedPriceMargin = { "top": "0px", "right": "0px", "bottom": "0px", "left": "3px" };
export const resetFeatureddButtonRadius = { top: "8px", right: "8px", bottom: "8px", left: "8px" };
export const resetFeaturedGetStartedPadding = { "top": "13px", "right": "16px", "bottom": "13px", "left": "16px" };
export const resetfooterDesMargin = { "top": "23px", "right": "0px", "bottom": "0px", "left": "0px" };


export const themePreview = [
	{
		label: "Style One",
		value: "style-1",
		img: "https://templates.bplugins.com/wp-content/uploads/2025/06/minimal-pricing1-Copy.png",
		height: "auto",
		width: "160px",
	},
	{
		label: "Style Two",
		value: "style-2",
		img: "https://templates.bplugins.com/wp-content/uploads/2025/06/horizatioal-pricing2-Copy.png",
		height: "auto",
		width: "160px",
	}
];